import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { Router } from '@angular/router';
import { ImportService } from '@services/imports/import.service';
import { MemoryService } from '@services/memory/memory.service';
import { DataTableComponent, DataTableEvent } from '../../../../components/data-table/data-table.component';
import { ImportTypeService } from '@services/import-types/import-type.service';

@Component({
    selector: 'composition-wizard-imports',
    templateUrl: './composition-wizard-imports.component.html',
    styleUrls: ['./composition-wizard-imports.component.scss'],
    providers: [ImportService, ImportTypeService],
    standalone: false
})
export class CompositionWizardImportsComponent implements OnInit {
  @ViewChild('assignedImportsTable') assignedImportsTable: DataTableComponent;
  @Input() composition: Models.Composition;

  public columnsAssignedImports = [{ prop: 'title' }];
  public columnsImportType = [{ prop: 'title' }];
  public columnsImport = [{ prop: 'title' }, { validate: '_id', name: 'Imported', icon: 'check_box' }];
  selectedImportType: false;

  public paramsImport: any;
  public assignedImportsProvider: MemoryService<Models.Import>;
  private assignedImports: Models.Import[];

  constructor(public importService: ImportService, public importTypeService: ImportTypeService, private router: Router) {
  }

  async ngOnInit() {
    this.assignedImports = [];
    this.assignedImportsProvider = new MemoryService(this.assignedImports);

    if (this.composition.importIds && this.composition.importIds.length > 0) {
      const response = await this.importService.find(0, 5000, { compositionId: this.composition._id });
      this.assignedImports = response.data;
      this.updateAssignedImports();
    }
  }

  public async assignImport(event: DataTableEvent) {
    if (this.assignedImports.find(i => i?._id === event?.row?._id)) {
      return;
    }

    const newImport = await this.importService.get(event.row._id);
    this.assignedImports.push(newImport);
    this.updateAssignedImports();
  }

  public removeAssignedImport(event: DataTableEvent): void {
    this.assignedImports.splice(event.index, 1);
    this.updateAssignedImports();
  }

  public onCustomImportType(event: DataTableEvent) {
    this.selectedImportType = this.selectedImportType === event.row._id ? false : event.row._id;
    this.paramsImport = this.selectedImportType === event.row._id ? {} : { typeId: event.row._id };
  }

  public onDetailImporter(event: DataTableEvent) {
    this.router.navigate(['imports/', event.row._id]);
  }

  private updateAssignedImports(): void {
    const importIds: string[] = [];
    for (let i = 0; i < this.assignedImports.length; i++) {
      importIds.push(this.assignedImports[i]._id);
    }
    this.composition.importIds = importIds;
    this.assignedImportsProvider.db = this.assignedImports;
    this.assignedImportsTable.refresh();
  }
}
